import { BookingLink } from "../components/BookingLink.tsx";
import { Link } from 'react-router-dom';
import { SiteHeader } from '../components/SiteHeader.tsx';
import { SiteFooter } from '../components/SiteFooter.tsx';
import './book.css';

export function NotFound() {
  return (
    <>
      <SiteHeader variant="inner" />
      <main className="not-found">
        <div className="page stack-lg">
          <p className="eyebrow">404</p>
          <h1>This page has drifted off</h1>
          <p className="lede" style={{ marginInline: 'auto' }}>
            The page you were looking for is not here. The treatment menu and booking are both a
            tap away.
          </p>
          <div className="row" style={{ justifyContent: 'center' }}>
            <Link to="/" className="btn btn--ghost">
              Back to the studio
            </Link>
            <BookingLink className="btn">
              Book an appointment
            </BookingLink>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
